import Cookie from './cookies.js';

$(document).ready(function(){

	// Autostart the Fancybox popup.
	setTimeout(function(){

		// Ignore if the popup is already open.
		if ( Cookie.getCookie( 'popup' ) ) {
			return;
		}

		Fancybox.show([{
			src: "#js-popup",
			type: "inline"
		}], {
			on: {
				close: () => {
					Cookie.setCookie( 'popup', 'opened', { path: "/" } );
				}
			} 
		});

	}, 2000);
});
